import { gql } from '@apollo/client';

export const RECOMPUTE_SIMULATIONS_COMPLETED = gql`
  subscription recomputeSimulationsCompleted($documentId: Int!, $siteId: Int!) {
    recomputeSimulationsCompleted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      simulationsGenerated
      filters {
        acquisitionPrice
        currencyCode
        financingPeriod {
          minValue
          maxValue
          step
          value
        }
        advancePercent {
          minValue
          maxValue
          step
          value
        }
        residualValuePercent {
          minValue
          maxValue
          step
          value
        }
        rezidualValue {
          minValue
          maxValue
          step
          value
        }
        agreedMileage
      }
      contractTypeIds
    }
  }
`;
